import { post } from "../axiosClient";

export const PATH_ADMIN_WEBSYSTEM = 'admin/websystem'
export const PATH_ADMIN_CYPHERS_PDF = 'admin/cypher/pdf'

type UploadWebsystemProps = {
    file: string | File,
    token: string,
    path: string,
    params: any
}

type UploadWebsystemResponse = {
    success: boolean
    errorMessage?: string
}

export const uploadFile = async ({ file, token, path, params }: UploadWebsystemProps): Promise<UploadWebsystemResponse> => {
    console.log(file)
    const formData = new FormData();
    formData.append('file', file);

    return await post({
        data: formData,
        params: params,
        path: path,
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { success: true }
        } else {
            return {
                success: false,
                errorMessage: res.data
            }
        }
    });
}